import backend from '@common/backend';
import normalizeMeets from '@common/helpers/normalizeMeets';
import { AvailableReworkingSlotsQuery, AvailableSlot } from '@common/types/academyReworkings';

const BASE = '/meetSlots';

// export const getMeetSlots = (query: any) =>
// 	backend.get(`${BASE}`, {
// 		params: query,
// 	});

export const getMeetSlots = async (query: any) => {
	const response = await backend.get(`${BASE}`, {
		params: query,
	});

	const normalized = normalizeMeets(response);
	return normalized;
};

// Keep individual free tutor slots; consultation normalization combines booked slots.
export const getAvailableReworkingSlots = (
	query: AvailableReworkingSlotsQuery,
): Promise<AvailableSlot[]> => backend.get(BASE, { params: query });

export const createMeetSlot = async (data: any) => backend.post(`${BASE}`, data);

export const createMeetSlotBulk = async (data: any[]) => backend.post(`${BASE}/bulk`, data);

export const removeMeetSlot = async (id: number) => backend.delete(`${BASE}/${id}`);
